var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionIncomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35909 9.72301H5.23641L10.8831 4.08313C11.0112 3.95502 11.0832 3.78127 11.0832 3.6001C11.0832 3.41893 11.0112 3.24518 10.8831 3.11707C10.755 2.98896 10.5812 2.91699 10.4001 2.91699C10.2189 2.91699 10.0451 2.98896 9.91703 3.11707L4.27715 8.76375V5.64107C4.27715 5.46064 4.20547 5.28759 4.07789 5.16001C3.9503 5.03242 3.77726 4.96075 3.59683 4.96075C3.41639 4.96075 3.24335 5.03242 3.11577 5.16001C2.98818 5.28759 2.9165 5.46064 2.9165 5.64107V10.4033C2.91758 10.4922 2.93607 10.5801 2.97093 10.6619C3.03997 10.8281 3.17207 10.9602 3.3383 11.0292C3.42009 11.0641 3.50792 11.0826 3.59683 11.0837H8.35909C8.53953 11.0837 8.71257 11.012 8.84015 10.8844C8.96774 10.7568 9.03942 10.5838 9.03942 10.4033C9.03942 10.2229 8.96774 10.0499 8.84015 9.92227C8.71257 9.79469 8.53953 9.72301 8.35909 9.72301Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionIncomeIcon);
export default __webpack_public_path__ + "static/media/transaction-income-icon.cf0095e00280ee3171de92467e2138c1.svg";
export { ForwardRef as ReactComponent };